import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '91动漫',
        url: 'https://www.91anime.com',
        description: '91动漫是深受动漫迷喜爱的在线动漫平台，提供海量高清正版动漫资源，涵盖热血、恋爱、悬疑、奇幻等多种类型。',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'contact@91anime.com',
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '91动漫',
        url: 'https://www.91anime.com',
        description: '正版高清动漫在线观看平台 - 91动漫免费追番',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.91anime.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '91动漫 - 正版高清动漫在线观看平台',
        description: '91动漫是深受动漫迷喜爱的在线动漫平台，提供海量高清正版动漫资源。涵盖热血、恋爱、悬疑、奇幻等多种类型，支持免费在线观看与追番提醒。',
        url: 'https://www.91anime.com',
        isPartOf: { '@id': 'https://www.91anime.com/#website' },
        about: { '@id': 'https://www.91anime.com/#organization' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '91动漫是免费的吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '是的，91动漫平台上的所有番剧均支持免费在线观看。我们致力于为动漫爱好者提供优质、便捷的观番体验。',
            },
          },
          {
            '@type': 'Question',
            name: '91动漫支持哪些设备观看？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '91动漫支持全平台观看，您可以在电脑、平板和手机浏览器上直接访问我们的网站。',
            },
          },
          {
            '@type': 'Question',
            name: '91动漫的番剧资源是否正版？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '91动漫高度重视版权保护，平台上所有动漫资源均获得正版授权。',
            },
          },
          {
            '@type': 'Question',
            name: '91动漫有哪些动漫类型？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '91动漫涵盖热血、恋爱、悬疑、奇幻、搞笑、日常、机战、恐怖等多种类型。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="91动漫 - 正版高清动漫在线观看平台 | 免费追番"
        description="91动漫是深受动漫迷喜爱的在线动漫平台，提供海量高清正版动漫资源，涵盖热血、恋爱、悬疑、奇幻等多种类型。91动漫支持免费在线观看与追番提醒，让每一位动漫爱好者都能畅享极致观番体验。"
        keywords="91动漫,91动漫在线观看,91动漫免费追番,高清动漫平台,正版动漫网站,热门动漫推荐,动漫番剧大全"
        ogImage="https://readdy.ai/api/search-image?query=91%20anime%20website%20homepage%20with%20colorful%20anime%20characters%20collage%2C%20warm%20vibrant%20atmosphere%2C%20Chinese%20anime%20streaming%20platform%20banner%2C%20professional%20design&width=1200&height=630&seq=og-home&orientation=landscape"
        structuredData={structuredData}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}